module.exports = __webpack_public_path__ + "img/Icon-16.555d479a.svg";